import "./errorNumber.scss"

function ErrorNumber() {
   return (
      <div className="error-number">
         <div className="error-number__digit">4</div>
         <div className="error-number__digit">0</div>
         <div className="error-number__digit">4</div>
      </div>
   )
}

export default ErrorNumber